import isEmpty from 'lodash/isEmpty'
import { useDispatch, useSelector } from 'react-redux'

import { toggleFavoriteStart } from 'store/redux-slices/casinoMenu'
import { toast } from '../components/Toast'

/**
 * Custom hook to manage favorite games functionality
 * @returns {{favoriteGamesList: Object}} Object containing the list of favorite games
 */
const useFavoriteGames = () => {
  const dispatch = useDispatch()
  const { userDetails } = useSelector(state => state?.user)
  const { favoriteGamesList } = useSelector((state) => state?.casinoMenu)
  const { languageData } = useSelector((state) => state.language)
  const isLoggedIn = !isEmpty(userDetails)

  /**
   * Toggles the favorite status of a game
   * @param {Object} params - The parameters object
   * @param {boolean} params.isFavorite - Current favorite status of the game
   * @param {string|number} params.id - The category game ID
   * @returns {void}
   */
  const toggleFavorite = ({ isFavorite, categoryGameId, id }) => {

    if (isLoggedIn) {
      dispatch(toggleFavoriteStart({
        isFavorite,
        categoryGameId,
        id
      }))
    } else {
      toast(languageData?.loginFirst, 'error')
    }
  }

  return {
    favoriteGamesList,
    toggleFavorite
  }
}

export default useFavoriteGames

// TODO: Home Page
// TODO: Casino Page
// TODO: Recent Games
// TODO: Casino Fav Games
// TODO: Promotion Detail Page
// TODO: Game Play page
// TODO: Demo Play page
